/**
 * @desc: - 投注选号 - 六合彩
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[STRING]} items:        [选项: 多个选项由单竖线隔开 0|2|3 ]
 * @param  {[STRING]} prize:        [奖金组]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: ammo
 */
import ReactDOM from 'react-dom';
import { POS_INTEGER } from '../../../../constants/regulars'

export default class BetLhc extends React.Component {

	constructor(props) {
		super(props);
    this.makeCodesArea = this.makeCodesArea.bind(this);
    this.handleInput = this.handleInput.bind(this);
	}

  // 改变值
  handleInput(money, methodid){
    this.props.onChange(money, methodid);
  }

  // 判断重新渲染
  shouldComponentUpdate(nextProps, nextState){
      // 强制刷新
      if (this.props.resetToken != nextProps.resetToken) {
        return true;
      }
      // 改变奖金组刷新
      if (this.props.prize != nextProps.prize) {
        return true;
      }
      return false;
  }   

  // 生成选号区域
  makeCodesArea(){
    const { items, prize } = this.props;
    const _columns = _.times(Math.ceil(items.length/10), ''); 
    let doms = [];
    _.forEach(_columns, function(item, index){
      let colDom = [];
      for(let i = 0; i< 10; i++){
        const current = items[index * 10 + i];
        if (current) {
          if (i === 0) {
            colDom.push(<BetLhcTitle key={_.random(100000)} />);
          }
          colDom.push(<BetLhcCode 
              key={_.random(100000)}
              className={current.color} 
              num={current.num} 
              methodid={current.methodid} 
              prize={prize} 
              value={current.value} 
              handleInput={this.handleInput} />)
        }
      }
      // 添加
      doms.push(colDom);
    }.bind(this))
    return doms.map((item, index) => <dl key={index}>{item.map((it) => it)}</dl>);
  }

	render() {
		const {className} = this.props;
		return (
			<div className="lotteryView lotteryView_lhc">
        <div className="Contentbox">
          <div className="lhcBox"> 
            {
              this.makeCodesArea()
            }
          </div>
        </div>
			</div>
		);
	}
}

// 单个号码组件
class BetLhcCode extends React.Component {

  constructor(props) {
    super(props);
    this.handleOnchange = this.handleOnchange.bind(this);
    this.state={
      hasClass:false
    }
  }

  // 输入限制
  handleOnchange(){
    const { handleInput, methodid } = this.props;
    let money = ReactDOM.findDOMNode( this.refs.money ).value;
    if (!POS_INTEGER.test(money)) {
      ReactDOM.findDOMNode( this.refs.money ).value = '';
      money = '';
      this.setState({
        hasClass : false
      })
    }else{
      this.setState({
        hasClass : true
      })
    }
    handleInput(money, methodid);
  }
  render() {
    const {className, num, prize, value} = this.props;
    return (
      <dd className={this.state.hasClass?"active":null}>
        <span className={className}>{num}</span>
        <span className="num">{  $.formatPrizeDisplay(prize) }</span>
        <span className="input">
          <input ref="money" 
            type="text" 
            defaultValue={value} 
            onChange={_.debounce(this.handleOnchange, 500)} />
        </span>
      </dd>
    );
  }
}

// 表头组件
class BetLhcTitle extends React.Component {
  render() {
    return (
      <dt><span>号码</span><span>赔率</span><span>金额</span></dt>
    );
  }
}